const trim = (str: string | undefined | number) => {
  if (typeof str === "string") {
    return str.trim();
  }
  if (typeof str === "number") {
    return str.toString().trim();
  }
  return "";
};

export default trim;
